<template>
	<div>
		<div v-if="eventNotfound" class="alert alert-info">
			{{ t.error.notfound_fixture }}
		</div>

		<table class="table table-padded" v-if="loader">
			<tbody>
			<tr class="competition_head">
				<td colspan="10"><strong>{{ t.loading.fixture }}</strong></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			<tr>
				<td colspan="10"><ContentPlaceholder :rows="placeholderRows"></ContentPlaceholder></td>
			</tr>
			</tbody>
		</table>

		<div class="white-box match-e" v-for="sport in events" v-if="events">

			<div class="white-box match-e" v-for="region in sport.region" v-if="events">
			<table class="table table-padded" v-for="comp in region.competition">
				<tbody>
				<tr >
					<td class="competition_head" colspan="10"><strong>{{sport.name}} » {{region.name}} » {{ comp.name }}</strong>
            <select style="width: 150px" name="x" class="form-control pull-right" @change="saveClass(comp)" v-if="comp.class" v-model="comp.class">
              <option v-for="c in classes" :value="c.id">{{ c.name }}</option>
            </select>
          </td>
				</tr>
				<tr v-for="match in comp.matches">
					<td width="110" style="word-wrap: break-word;">
						<span v-if="t.fixture.status.length > 0">
							<span class="status-pill smaller green"></span><span>{{ t.fixture.status[match.result.type] | slimiter(10) }} </span>
						</span>
					</td>
					<td width="120" class="text-center px-1">
						{{ match.startDate | moment('dddd', session.timezone) | slimiter(10) }}
						<span class="smaller lighter">
							{{ match.startDate | moment(session.date_format, session.timezone) }} / {{ match.startDate | moment('HH:MM', session.timezone) }}
						</span>
					</td>
					<td width="200" class="text-right">
						<a href="#">
							{{ match.competitor.oneName | slimiter(25) }}
						</a>
					</td>
					<td width="30" class="p-0 text-center competition_head">
						<img width="25" height="25" :src="'https://ls.sportradar.com/ls/crest/medium/'+match.competitor.oneEid+'.png'"/>
					</td>
					<td width="50" class="p-0 text-center">
						VS
					</td>
					<td width="30" class="p-0 text-center competition_head">
						<img width="25" height="25" :src="'https://ls.sportradar.com/ls/crest/medium/'+match.competitor.twoEid+'.png'"/>
					</td>
					<td width="200" class="text-left">
						<a href="#">
							{{ match.competitor.twoName | slimiter(25) }}
						</a>
					</td>
					<td width="60">
            <select style="width: 150px" name="x" class="form-control pull-right" @change="saveMatchClass(match)" v-model="match.class">
              <option v-for="c in classes" :value="c.id">{{ c.name }}</option>
            </select>
						<div id="toggles" class="pt-2 pull-right" v-tooltip="t.disable_this_match_on_the_fixture">
							<input type="checkbox" class="ios-toggle" v-on:change="changeStatus(match.matchId, match.IsDisableOnApp)" :id="'ou_'+match.matchId" v-model="match.IsDisableOnApp" :name="'ou_'+match.matchId" value="1" v-if="">
							<label :for="'ou_'+match.matchId" class="checkbox-label"></label>
						</div>
					</td>
				</tr>
				</tbody>
			</table>
			</div>
		</div>

		<paginate v-if="pagination.pageCount"
				:page-count="pagination.pageCount"
				:page-range="pagination.pageRange"
				:force-page="(pagination.current-1)"
				:margin-pages="2"
				:click-handler="onChangePage"
				:prev-text="t.previous"
				:next-text="t.next"
				:container-class="'pagination float-right'"
				:page-class="'page-item'"
				:page-link-class="'page-link'"
				:prev-class="'page-item'"
				:prev-link-class="'page-link'"
				:next-class="'page-item'"
				:next-link-class="'page-link'"
		>
		</paginate>
	</div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import ContentPlaceholder from 'vue-content-placeholder'
    import feed from '@/mixins/feed.js'

    export default {
        name: 'matches',
	    components: { ContentPlaceholder, Paginate },
      mixins: [feed],
        props: {
            filter: {}
        },
        data () {
            return {
                app: this.$root.app,
                session: window.session,
                loader: true,
                t: this.$root.t,
                events: [],
                eventNotfound: false,
	              loader: false,
                selectedEventDate: false,
                session: session,
	              pagination: [],
	              page: 1,
                classes: [],
                placeholderRows:  [

                    { height: '1rem',
                        boxes: [[0, '20%'], ['2%', '15%'], ['2%', '30%'], ['20%', '8%']]
                    },

                ]
            }
        },
        watch: {
            'filter' () {
                this.fetchEvents();
            }
        },
	    mounted () {

            this.fetchAllClass().then(response => {
              response.body.forEach((e) => {
                this.classes.push({name: e.name, id: e.id})
              });
            });

            this.fetchEvents();
	    },
	    methods: {
            changeStatus (m, d) {
                this.$http.get(api+'api/v1/fixture/api_v1_set_match_is_disable', {
                    params: {data: d, match: m }
                }).then(response => {
                    // get body data


                }, response => {
                    // error callback

                })
                },
            saveMatchClass(c){
              this.$http.get(api+'api/v1/match/class/'+c.matchId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            saveClass(c){
              this.$http.get(api+'api/v1/competition/class/'+c.competitionId+'/'+c.class).then(response => {
                // get body data

              }, response => {
                // error callback

              })
            },
            onChangePage (page) {
                this.pagination.current = page;
                this.filter.page = page;
                this.$router.push({ query: {} });
                this.$router.push({ query: this.filter });
            },
            fetchEvents () {
                this.loader = true;
                this.events = [];
                this.eventNotfound = false;
                this.$http.get(bsapi+'api/v1/fixture/matches?fullList=true&app='+this.app.id, {
					params: this.filter
                }).then(response => {
                    // get body data
                    this.events = response.body.result.sport;
                    this.pagination = response.body.pagination;
                    this.loader = false;
                    this.eventNotfound = false;

                }, response => {
                    // error callback
                    this.eventNotfound = true;
                    this.loader = false;
                })
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.competition_head{
		border-bottom: 3px solid #73518e !important;
	}
	h1, h2 {
		font-weight: normal;
	}

	ul {
		list-style-type: none;
		padding: 0;
	}

	li {
		display: inline-block;
		margin: 0 10px;
	}

	a {
		color: #42b983;
	}
</style>



// WEBPACK FOOTER //
// src/components/stats/matches.vue